module.exports = __webpack_public_path__ + "static/media/6C-0@3x.ba8333d4.png";